/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest interface.
 */
export function instanceOfFxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest(value) {
    if (!('DocumentId' in value) || value['DocumentId'] === undefined)
        return false;
    if (!('DocumentVersionId' in value) || value['DocumentVersionId'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequestFromJSON(json) {
    return FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DocumentId': json['DocumentId'],
        'DocumentVersionId': json['DocumentVersionId'],
    };
}
export function FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequestToJSON(json) {
    return FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'DocumentId': value['DocumentId'],
        'DocumentVersionId': value['DocumentVersionId'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesDocumentsAcceptDocumentAcceptDocumentRequest.js.map